import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Step4 } from '../../../../../shared/models/component-messages/mapaAT/step4';
import { FormExtractorService } from '../../../../../shared/services/form-extractor.service';
import { ObjectToJsonStepperCreatorService } from '../../../../../shared/services/object-to-json-stepper-creator.service';
import { RadioCheckBoxEnum } from '../../../../common/radio.checkbox.enums';
import { CTRL_331 } from '../../../../validators/331/ctrl331';
import { FormMapaATControlNames } from '../../formMapaATControlNames';
import { TypeAttributionMarcheLot } from '../../models/TypeAttributionMarcheLot';
import { CTRL_268 } from '../../../../validators/268/ctrl268';
import { AvisDataTransferService } from '../../../../../shared/services/avis-data-transfer.service';

@Component({
  selector: 'app-step4',
  templateUrl: './step4.component.html'
})
export class Step4Component implements OnInit {

  @Input() attribue: TypeAttributionMarcheLot;
	@Input() parentForm: FormGroup;
	@Input() disabled: boolean;
	@Input() uid = '';
	@Input() linkForRouter: string;

  public step4 = new Step4();
  public rg1 = CTRL_268.id + '_2';

  constructor(private formExtractorService: FormExtractorService, public objectToJsonStepperCreatorService: ObjectToJsonStepperCreatorService,
    private avisDataTransferService: AvisDataTransferService) { }

  ngOnInit(): void { }

  getUid() {
    return this.uid + '_SepSep_AttributionFromMAPA_SepSep_Attribution_SepSep_TypeResultatAttribution';
  }

  public getType() {
    return this.avisDataTransferService.getFormData().jsonSaisieFormulaire.ann.mapa.attributionFromMAPA.resultatAttribution;
  }
  public isAttribue(): boolean {
    return this.getType() !== RadioCheckBoxEnum.sansSuite
      && this.getType() !== RadioCheckBoxEnum.infructueux;
    }

  public isAttributionUnique(): boolean {
    if (this.getType() === RadioCheckBoxEnum.attribueUnique) {
			this.parentForm.addControl(this.getStepId() + this.rg1, new FormControl({ rgCtrls: this.getCtrl_268Names_json() }));
		}
    return this.getType() === RadioCheckBoxEnum.attribueUnique;
  }

  getStepId() {
		return this.uid.substring(0, this.uid.indexOf("SepSep"));
	  }

	  private getCtrl_268Names_json(): any {
		const deptPub = '_SepSep_TypeIndexation_SepSep_TypeDept_SepAtt_deptPub';
		const cp = '_SepSep_AttributionFromMAPA_SepSep_Attribution_SepSep_TypeResultatAttribution_SepSep_TypeAttributionMarcheLot_SepSep_TypeAdresseCompleteMorale_SepSep_TypeAdresse_SepAtt_cp';
		return { firstChamp: deptPub, secondChamp: cp };
	  }
}
